import React from 'react';
import PokemonCard from './PokemonCard';

function PokemonGrid({ pokemon, loading = false }) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow-md p-4 animate-pulse">
            <div className="flex justify-center mb-4">
              <div className="w-24 h-24 bg-gray-300 rounded"></div>
            </div>
            <div className="text-center">
              <div className="h-6 bg-gray-300 rounded mb-2"></div>
              <div className="h-4 bg-gray-300 rounded mb-3 w-16 mx-auto"></div>
              <div className="flex justify-center space-x-1 mb-3">
                <div className="h-6 bg-gray-300 rounded-full w-16"></div>
              </div>
              <div className="grid grid-cols-3 gap-2">
                <div className="h-8 bg-gray-300 rounded"></div>
                <div className="h-8 bg-gray-300 rounded"></div>
                <div className="h-8 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!pokemon || pokemon.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No Pokemon found.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {pokemon.map((pokemon, index) => (
        <PokemonCard key={pokemon.id} pokemon={pokemon} index={index} />
      ))}
    </div>
  );
}

export default PokemonGrid;